import React, {FunctionComponent, useState} from "react";

export type GarageProfileRatingContentProps = {
    text: string
};

export const GarageProfileRatingContent: FunctionComponent<GarageProfileRatingContentProps> = ((props: GarageProfileRatingContentProps) => {

    const [isReadMore, setIsReadMore] = useState(true);


    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };


    return (
        <p className={'text-base leading-6 font-normal text-gray-700 mb-2'}>
            {props.text.length > 350 && isReadMore ? props.text.slice(0, 300) + '...' : props.text}
            {props.text.length > 350 &&
                <span onClick={toggleReadMore} className="read-or-hide block font-bold cursor-pointer">
                                {isReadMore ? "mehr lesen" : " weniger anzeigen"}
                            </span>
            }
        </p>
    );

})